import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import { ErrorToaster } from "../components/toaster/Toaster";
import { generatePdf } from "../../utils/helper";
import dayjs from "dayjs";
import { Table } from "antd";
import { useSelector } from "react-redux";
import StateServices from "../../services/State";
import DeliveryManagementServices from "../../services/DeliveryManagement";

const DeliveryReceipt = () => {

  const invoiceRef = useRef([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const { userData } = useSelector((state) => {
    return {
      userData: state.user_data
    }
  });

  const storeLogo = userData?.store?.logoBase64 || '/assets/img/mattress-plus-logo.png'

  // *For Loading
  const [loading, setLoading] = useState(false);

  // *For Delivery Receipt
  const [deliveryReceipts, setDeliveryReceipts] = useState([]);

  // *For Generate PDF
  const handleGeneratePdf = async () => {
    setLoading(true)
    try {
      await generatePdf(invoiceRef?.current)
    } catch (error) {
      console.log('handleGeneratePdf => error:', error)
    } finally {
      setLoading(false)
    }
  };

  // *For Get Delivery Receipts
  const getDeliveryReceipts = async () => {
    try {
      const obj = {
        id: searchParams.get('id').split(',')
      }
      const { data } = await DeliveryManagementServices.getDeliveryReceipts(obj)
      setDeliveryReceipts(data)
      invoiceRef.current = Array.from({ length: data.length }, (_, i) => invoiceRef.current[i] || React.createRef());
    } catch (error) {
      ErrorToaster(error)
    }
  }

  useEffect(() => {
    if (searchParams) {
      getDeliveryReceipts()
    }
  }, [searchParams]);

  const columns = [
    {
      title: "Brand",
      dataIndex: "item",
      render: (text) => (
        <span>
          {text?.brand?.name}
        </span>
      ),
    },
    {
      title: "Product",
      dataIndex: "item",
      render: (text, record) => (
        <span>
          {text?.name}&nbsp;
          {record?.variant?.attributes &&
            Object.values(record?.variant?.attributes).join('-')
          }
        </span>
      ),
    },
    // {
    //   title: "Size",
    //   dataIndex: "size",
    //   render: (text) => (
    //     <span>
    //       {text?.name}
    //     </span>
    //   ),
    // },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   render: (text) => (
    //     <span>
    //       {text}
    //     </span>
    //   ),
    // },
    {
      title: "Qty",
      dataIndex: "quantity",
      render: (text) => (
        <span>
          {text}
        </span>
      ),
    },
    {
      title: "Shipping Type",
      dataIndex: "delivery_type",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
    {
      title: "Section",
      dataIndex: "section",
      render: (text) => (
        <span>
          {text}
        </span>
      ),
    },
    {
      title: "Bay",
      dataIndex: "bay",
      render: (text) => (
        <span>
          {text}
        </span>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>View Delivery Receipt</h4>
            </div>
          </div>
          <div className="page-btn">
            <button disabled={loading} className="btn btn-added" onClick={() => handleGeneratePdf()}>
              <PlusCircle className="me-2 iconsize" />
              Print
            </button>
          </div>
        </div>

        <div className="card-body mb-3">
          <div className="card m-auto" style={{ width: '950px' }}>
            {deliveryReceipts.map((item, index) => (
              <div key={index} ref={invoiceRef.current[index]}>
                <div className="card-body add-product p-4">
                  <div className="row justify-content-between mb-1">
                    <div className="col-md-4">
                      <img src={storeLogo} alt="img" style={{ height: 'auto', width: 'auto', objectFit: 'contain' }} />
                      <p className="mb-1">{userData?.store?.address.split(',')[0]}</p>
                      <p className="mb-1">{userData?.store?.address.split(', ').splice(1).join(', ')}</p>
                      <p className="mb-1">{userData?.store?.phone_number}</p>
                    </div>
                    <div className="col-md-5">
                      <h3 className="mb-1">DELIVERY RECEIPT</h3>
                      <div className="row">
                        <div className="col-md-4">
                          <p>Purchase Date:</p>
                        </div>
                        <div className="col-md-8">
                          <p>{dayjs(item?.order_date).format('MM-DD-YYYY')}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <p>Order:</p>
                        </div>
                        <div className="col-md-8">
                          <p>{item?.order_number}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <p>Delivery Date:</p>
                        </div>
                        <div className="col-md-8">
                          <p>{dayjs(item?.delivery_date).format('MM-DD-YYYY')} / {item?.delivery_day}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <p>Time Frame:</p>
                        </div>
                        <div className="col-md-8">
                          <p>{item?.delivery_time_slot?.name}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-between">
                    <div className="col-md-5">
                      <h6 className="text-center py-1" style={{ backgroundColor: 'rgb(0,176,240)', color: '#fff' }}>Delivery Info</h6>
                      <div className="row">
                        <div className="col-md-4">
                          <p>Name:</p>
                        </div>
                        <div className="col-md-8">
                          <p>{item?.shipping_name} {item?.shipping_last_name}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <p>Address:</p>
                        </div>
                        <div className="col-md-8">
                          <p>{item?.shipping_address}, {item?.shipping?.name} {item?.shipping?.state?.name}, {item?.shipping_zip_code}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <p>Phone:</p>
                        </div>
                        <div className="col-md-8">
                          <p>{item?.shipping_phone_number_one}, {item?.shipping_phone_number_two}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <p>Email:</p>
                        </div>
                        <div className="col-md-8">
                          <p>{item?.shipping_email}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <h4 className="text-center py-3" style={{ backgroundColor: 'rgb(255,255,0)', color: item?.balance_amount > 0 ? 'rgb(255,0,0)' : '#000' }}>Balance Due: <b>${parseFloat(item?.balance_amount).toFixed(2)}</b></h4>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="addproduct-icon" style={{ paddingBottom: '10px', marginBottom: '10px' }}>
                    </div>
                    <Table
                      className="table datanew dataTable no-footer custom-table"
                      columns={columns}
                      dataSource={item?.sale_invoice_items}
                      pagination={false}
                    />
                    <div className="mt-3 mb-1">
                      <h5 className="p-2" style={{ backgroundColor: 'rgb(255,0,0)', color: '#fff' }}>The delivery team will NOT take away existing bed frames, adjustable bases or furniture.</h5>
                    </div>
                    <div className="mt-1">
                      <h5 className="p-2">I confirm that all goods received are in good order and condition.</h5>
                    </div>
                  </div>

                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div >
  );
};

export default DeliveryReceipt;
